import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";  
import Layout from "../Layout";

const NotFound = lazy(() => import("../notFound/NotFoundPage"));
const Home = lazy(() => import("../pages/home/Home"));
const PropertyDetail = lazy(() => import("../pages/home/PropertyDetail"));
const SearchedPropertyList = lazy(() => import('../pages/home/SearchedPropertyList'));

const About = lazy(() => import("../pages/about/About"));

const FAQ = lazy(() => import("../pages/support/FAQ"));
const Contact = lazy(() => import("../pages/support/Contact"));

const BuildGreen = lazy(() => import("../pages/build_green/BuildGreen"));

const Blogs = lazy(() => import("../pages/learn/Blogs"));
const BlogDetail = lazy(() => import("../pages/learn/BlogDetail"));

const RouteWrapper = ({ children, useLayout = true }) => {
  return useLayout ? <Layout>{children}</Layout> : <>{children}</>;
};

const AppRoutes = () => {
  return (
    <Suspense fallback={<div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<RouteWrapper useLayout={true}><Home /></RouteWrapper>} />
        <Route path="/home/property/:id" element={<RouteWrapper useLayout={true}> <PropertyDetail /> </RouteWrapper> } />
        <Route path="/about" element={<RouteWrapper useLayout={true}><About /></RouteWrapper>} />
        <Route path="/support/faqs" element={<RouteWrapper useLayout={true}><FAQ /></RouteWrapper>} /> 
        <Route path="/support/contact" element={<RouteWrapper useLayout={true}><Contact /></RouteWrapper>} />
        <Route path="/build-green" element={<RouteWrapper useLayout={true}><BuildGreen /></RouteWrapper>} />
        <Route path="/learn/blogs" element={<RouteWrapper useLayout={true}><Blogs /></RouteWrapper>} /> 
        <Route path="/learn/blogs/blog-detail" element={<RouteWrapper useLayout={true}><BlogDetail /></RouteWrapper>} />
        <Route path="/home/search-properties" element={<RouteWrapper useLayout={true}><SearchedPropertyList /></RouteWrapper>} />

        <Route path="*" element={<RouteWrapper useLayout={true}><NotFound /></RouteWrapper>} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;